import { render, staticRenderFns } from "./DataLayerRow.vue?vue&type=template&id=5ddb693a&"
import script from "./DataLayerRow.vue?vue&type=script&lang=js&"
export * from "./DataLayerRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ddb693a')) {
      api.createRecord('5ddb693a', component.options)
    } else {
      api.reload('5ddb693a', component.options)
    }
    module.hot.accept("./DataLayerRow.vue?vue&type=template&id=5ddb693a&", function () {
      api.rerender('5ddb693a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/datalayers/DataLayerRow.vue"
export default component.exports